/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useState } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { loadStripe } from "@stripe/stripe-js";
import { useTranslation } from "react-i18next";

// Component imports
import {
  EmbeddedCheckoutProvider,
  EmbeddedCheckout,
} from "@stripe/react-stripe-js";
import { Container } from "@/components/UI/Container";
import { BackButton } from "@/components/UI/BackButton";
import { Card, Col, Row } from "antd";

// misc imports
import { NAV_SUBSCRIPTION_PLANS, STRIPE_PUBLIC_KEY } from "@/constants";
import replaceUrlParams from "@/utils/string/replaceUrlParams";

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

export const Checkout = () => {
  const location = useLocation();
  const { state } = location;
  const { client_secret } = state ?? {};
  const { t } = useTranslation();

  const { workspaceId, projectId } = useParams();

  // Get the lookup key for the price from the previous page redirect.
  const [clientSecret] = useState(client_secret);

  if (!clientSecret) {
    return (
      <Navigate
        to={replaceUrlParams(NAV_SUBSCRIPTION_PLANS, {
          workspaceId: workspaceId as string,
          projectId: projectId as string,
        })}
      />
    );
  }

  return (
    <Container>
      <Row>
        <Col xs={24}>
          <BackButton
            to={replaceUrlParams(NAV_SUBSCRIPTION_PLANS, {
              workspaceId: workspaceId as string,
              projectId: projectId as string,
            })}
          />
        </Col>
      </Row>

      <Card title={t("subscription_plans.checkout_card_title")}>
        <div id="checkout">
          {clientSecret && (
            <EmbeddedCheckoutProvider
              stripe={stripePromise}
              options={{ clientSecret }}
            >
              <EmbeddedCheckout />
            </EmbeddedCheckoutProvider>
          )}
        </div>
      </Card>
    </Container>
  );
};
